/* Custom Callout Tooltip for <ui-finish> — defaults to registry label */
(function () {
  const MARGIN = 10;
  const VIEWPAD = 8;

  const $tip = document.createElement("div");
  $tip.className = "finishCallout";
  $tip.setAttribute("role", "tooltip");
  $tip.dataset.state = "hidden";
  $tip.innerHTML = `<span class="finishCallout__inner"></span><span class="finishCallout__arrow"></span>`;
  document.addEventListener("DOMContentLoaded", () =>
    document.body.appendChild($tip)
  );

  let current = null;
  let rafId = null;

  const esc = (s) =>
    String(s ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/"/g, "&quot;");

  const humanize = (key) =>
    String(key || "")
      .replace(/[-_]+/g, " ")
      .replace(/\b\w/g, (m) => m.toUpperCase())
      .trim();

  function baseLabelFrom(el) {
    const name = el.getAttribute("name") || "";
    if (window.FinishRegistry) {
      const item = window.FinishRegistry.get(name);
      if (item && item.label) return item.label;
    }
    return humanize(name) || "Finish";
  }

  function getText(el) {
    // Priority: tt (custom string) > tooltip (custom string) > registry label
    const tt = el.getAttribute("tt");
    if (tt !== null) return tt.trim() !== "" ? tt : baseLabelFrom(el);
    const t2 = el.getAttribute("tooltip");
    if (t2 !== null) return t2.trim() !== "" ? t2 : baseLabelFrom(el);
    return baseLabelFrom(el);
  }

  function desiredPlacement(el) {
    const raw =
      el.getAttribute("callout") ||
      el.getAttribute("callout-placement") ||
      "auto";
    const v = String(raw).toLowerCase();
    return /^(top|bottom|left|right)$/.test(v) ? v : "auto";
  }

  function clamp(x, min, max) {
    return Math.max(min, Math.min(max, x));
  }

  function measure() {
    const r = $tip.getBoundingClientRect();
    return { w: r.width, h: r.height };
  }

  function place(el, pref = "auto") {
    const r = el.getBoundingClientRect();
    const { innerWidth: vw, innerHeight: vh } = window;

    let place = pref;
    if (place === "auto") {
      const spaceTop = r.top,
        spaceBottom = vh - r.bottom,
        spaceRight = vw - r.right,
        spaceLeft = r.left;
      if (spaceTop >= 48) place = "top";
      else if (spaceBottom >= 48) place = "bottom";
      else place = spaceRight >= spaceLeft ? "right" : "left";
    }

    $tip.dataset.placement = place;
    const { w, h } = measure();

    let top = 0,
      left = 0;
    if (place === "top") {
      top = r.top - h - MARGIN;
      left = r.left + r.width / 2 - w / 2;
    } else if (place === "bottom") {
      top = r.bottom + MARGIN;
      left = r.left + r.width / 2 - w / 2;
    } else if (place === "left") {
      top = r.top + r.height / 2 - h / 2;
      left = r.left - w - MARGIN;
    } /* right */ else {
      top = r.top + r.height / 2 - h / 2;
      left = r.right + MARGIN;
    }

    top = clamp(top, VIEWPAD, vh - h - VIEWPAD);
    left = clamp(left, VIEWPAD, vw - w - VIEWPAD);

    $tip.style.top = `${Math.round(top)}px`;
    $tip.style.left = `${Math.round(left)}px`;
  }

  function open(el) {
    if (!el || current === el) return;
    current = el;

    $tip.querySelector(".finishCallout__inner").textContent = getText(el);
    $tip.dataset.placement = desiredPlacement(el);
    $tip.dataset.state = "open";
    positionLoop();
  }

  function close(el) {
    if (el && el !== current) return;
    current = null;
    $tip.dataset.state = "hidden";
    if (rafId) cancelAnimationFrame(rafId);
    rafId = null;
  }

  function positionLoop() {
    if (!current) return;
    place(current, $tip.dataset.placement);
    rafId = requestAnimationFrame(positionLoop);
  }

  document.addEventListener("pointerover", (e) => {
    const el = e.target.closest("ui-finish[callout]");
    if (el) open(el);
  });
  document.addEventListener("pointerout", (e) => {
    if (!current) return;
    if (!e.relatedTarget || !current.contains(e.relatedTarget)) close(current);
  });
  document.addEventListener("focusin", (e) => {
    const el = e.target.closest("ui-finish[callout]");
    if (el) open(el);
  });
  document.addEventListener("focusout", (e) => {
    const el = e.target.closest("ui-finish[callout]");
    if (el) close(el);
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close(current);
  });
  document.addEventListener("visibilitychange", () => close(current));
})();
